import { isMobile } from './js-helpers.js';

class SiteWrapper extends HTMLElement {
	constructor() {
		super();

		this.spine = null;
	}

	connectedCallback() {
		isMobile
			? window.addEventListener('orientationchange', this.onFlipDevice)
			: window.addEventListener('resize', this.onResize);

		this.spine = document.getElementById('site-spine');
		this.getRows();
	}

	disconnectedCallback() {
		window.removeEventListener('orientationchange', this.onFlipDevice);
		window.removeEventListener('resize', this.onResize);
	}

	onFlipDevice = () => {
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.getRows();
			});
		});
	};

	onResize = () => {
		this.getRows();
	};

	getRows() {
		// const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
		const min = 25;
		const num = Math.max(
			25,
			Math.trunc((window.innerHeight - 14 - 16) / (16))
		);

		this.style.setProperty('--rows', num);

		if (!this.spine) return;

		this.spine.innerHTML = '';

		const fragment = document.createDocumentFragment();

		for (let i = 0; i < num; i++) {
			const li = document.createElement('li');
			li.className = 'site-spine-item font-sans-small';
			fragment.appendChild(li);
		}

		this.spine.appendChild(fragment);
	}
}

customElements.define('site-wrapper', SiteWrapper);
